import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing } from 'recompose';
import { DEFAULT_ADVERT_NO_GROUP_KEY } from '../../../../helpers/advert/advert';
import { getAdverts } from '../../../../store/reducers/content';
import { withLoader } from '../../../../components/template';
import { ConfigService } from '../../../../services/config-service';
import { withLoadingHandlers } from '../../../../components/with-loader';
import { withWidgetLoadingHandlers } from '../../../../components/layout/content/with-native-loading-state';
import { SET_WIDGET_STATE_ASYNC_SUCCESS } from '../../../../store/reducers/application';
import { Widget } from './component';

const mapStateToProps = ({ content }, { groupName = DEFAULT_ADVERT_NO_GROUP_KEY }) => ({
  adverts: content.adverts[groupName] ?? [],
  loadingAdverts: content.loadingAdverts[groupName]
});

export const DashboardAdverts = compose(
  connect(mapStateToProps, { getAdverts }),
  withLoadingHandlers(true),
  withWidgetLoadingHandlers,
  lifecycle({
    componentDidMount() {
      const { getAdverts, turnOnLoading, turnOffLoading, loadingAdverts, groupName, setWidgetLoadedState } = this.props;
      const isAdvertEnabled = ConfigService.get('DISPLAY_MODULES.ADVERT', false);

      turnOnLoading();
      if (isAdvertEnabled && !loadingAdverts) {
        const fetchAdverts = async () => await getAdverts({ groupName });
        fetchAdverts().then(setWidgetLoadedState(SET_WIDGET_STATE_ASYNC_SUCCESS, true));
      }
      turnOffLoading();
    }
  }),
  withLoader,
  branch(({ adverts, loading }) => !loading && adverts.length < 1, renderNothing)
)(Widget);
